/**
 * Similar to the dropStateSingleton, this is used to keep track of state while dragging.
 * A singleton is used because the drag layer will update on every mouse movement due to
 * the drag offset changing, so storing this state in redux would be wasteful as re-renders
 * are already going to happen.
 *
 * Drag and drop is one of the most performance sensitive operations, so we're trying to
 * refrain from adding extra workload unnecessarily.
 *
 * At the time of writing this comment, this is being used by the elementLineEdgeDropTarget
 * and DraggedLineEdgePreview in LineDragLayer to determine the element ID that's currently
 * hovered so that we can snap the line to that element in the drag preview.
 *
 * This is now also being used to track the "sourceOffset" which is how far in from the top
 * left corner has the element been grabbed.
 * This is used by the comment thread so that switching between the pin and the full comment
 * thread can be positioned correctly.
 */
const dragState = {
    hoveredElementId: null,
    // Offset from the top left corner of the element that it's been grabbed
    scaledGrabOffset: null,
};

export const clearDragStateSingleton = () => {
    dragState.hoveredElementId = null;
    dragState.scaledGrabOffset = null;
};

export default dragState;
